{
    "warning": "¡ADVERTENCIA!",
    "message": "No introduzcas ni pegues códigos que no comprendas.\nSi usas esta consola, los atacantes podrían suplantar tu identidad y robar tu información mediante un ataque llamado Self-XSS."
}
